import { render, staticRenderFns } from "./ForkIcon.vue?vue&type=template&id=138bede5&"
import script from "./ForkIcon.vue?vue&type=script&lang=js&"
export * from "./ForkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports